import { ShopBox, VehicleBox } from '@@partner:types:app'

// Гибридная схема для QR-кода
export interface BoxQRData {
  v: number // version
  t: string // type = "sb" (shop_box)
  s: string // shop_id
  b: string // box_id (A0101)
  n: number // box_number
  c: string // special_conditions code
  u: string // url path for API
}

// Маппинг условий хранения
const conditionsMap = {
  '': 'N',           // Normal
  'refrigerated': 'R', // Refrigerated  
  'frozen': 'F',       // Frozen
  'heated': 'H'        // Heated
}

const conditionsReverseMap = {
  'N': '',
  'R': 'refrigerated',
  'F': 'frozen', 
  'H': 'heated'
}

// Генерация данных для QR-кода
export const generateBoxQRData = (box: ShopBox | VehicleBox, shopId: string): BoxQRData => {
  const parsed = parseBoxNumber(box.number)
  const boxId = `${parsed.rowLetter}${parsed.column.toString().padStart(2, '0')}${parsed.place.toString().padStart(2, '0')}`

  const vehicleBox = (box as VehicleBox).vehicle_id ? box as VehicleBox : null
  
  return {
    v: 1,
    t: vehicleBox ? 'vb' : 'sb',
    s: vehicleBox ? `${vehicleBox.vehicle_id}` : shopId,
    b: boxId,
    n: box.number,
    c: conditionsMap[box.special_conditions || ''] || 'N',
    u: `/api/${vehicleBox ? 'vehicleBoxes' : 'boxes'}/${box.number}`
  }
}

// Конвертация в JSON строку для QR-кода
export const qrDataToString = (data: BoxQRData): string => {
  return JSON.stringify(data)
}

// Парсинг QR-кода обратно в данные
export const parseQRString = (qrString: string): BoxQRData | null => {
  try {
    const data = JSON.parse(qrString) as BoxQRData
    
    // Валидация структуры
    if (data.v && data.t === 'sb' && data.s && data.b && data.n && data.c && data.u) {
      return data
    }
    
    return null
  }
  catch {
    return null
  }
}

// Утилитарная функция для парсинга номера ящика (дублируем здесь для независимости)
const parseBoxNumber = (number: number): { rowLetter: string, column: number, place: number } => {
  const str = number.toString().padStart(5, '0')
  const rowNumber = parseInt(str[0])
  const column = parseInt(str.slice(1, 3))
  const place = parseInt(str.slice(3, 5))
  
  return {
    rowLetter: String.fromCharCode(65 + rowNumber - 1),
    column,
    place
  }
}

// Получение читаемого описания условий хранения
export const getConditionLabel = (code: string): string => {
  const conditionsLabels = {
    'N': 'Обычные',
    'R': 'Холодильные', 
    'F': 'Морозильные',
    'H': 'Подогреваемые'
  }
  
  return conditionsLabels[code as keyof typeof conditionsLabels] || 'Обычные'
}
